import React from 'react'
import styled from 'styled-components'

import { Text } from '@/components/Text'

import { ColorsMap, FontSizeMap, FontWeightMap, device } from '@/utils/Theme'

type Props = {
  player: string
}

const Item = ({ name, description, image }) => {
  return (
    <ItemImageWrapper>
      <ItemImage src={image} />
      <div>
        <Text textColor={ColorsMap.primary} fontSize={['l', 'm']} textAlign="center" fontWeight={FontWeightMap.bold}>
          {name}
        </Text>
        <Text
          textColor={ColorsMap.brownishGrey}
          textAlign="center"
          fontWeight={FontWeightMap.semibold}
          fontSize={FontSizeMap.s}
        >
          {description}
        </Text>
      </div>
    </ItemImageWrapper>
  )
}

const WITB = ({ player }: Props) => {
  if (player === 'beck') {
    return (
      <WITBWrapper reversed>
        <ItemsWrapper>
          <Items>
            <Item name="Cobra Darkspeed LS" description="Driver" image="/images/bags/beck/cobra_driver.png" />
            <Item
              name="Cobra Darkspeed LS 9.0"
              description="3-fairwayové drevo"
              image="/images/bags/beck/cobra_fairway.png"
            />
            <Item name="Cobra King TecUtility" description="3 železo" image="/images/bags/beck/king_tec_utility.png" />
            <Item name="Cobra King Tour" description="Železá" image="/images/bags/beck/king_tour.png" />
            <Item name="Cobra King Versatile" description="Wedge" image="/images/bags/beck/king_cobra.png" />
          </Items>
        </ItemsWrapper>
        <div>
          <PlayerImage src="/images/players/beck.jpg" />
        </div>
      </WITBWrapper>
    )
  }

  if (player === 'fowler') {
    return (
      <WITBWrapper>
        <div>
          <PlayerImage src="/images/players/fowler.jpg" />
        </div>
        <ItemsWrapper>
          <Items>
            <Item name="Cobra DS-Adapt X" description="Driver" image="/images/bags/fowler/cobra_driver.png" />
            <Item name="Cobra LTDx LS" description="5-fairwayové drevo" image="/images/bags/fowler/cobra_ltd.png" />
            <Item name="Cobra King Tour" description="Železá" image="/images/bags/fowler/king_tour.png" />
            <Item name="Cobra King Versatile" description="Wedge" image="/images/bags/fowler/king_cobra.png" />
          </Items>
        </ItemsWrapper>
      </WITBWrapper>
    )
  }

  if (player === 'homa') {
    return (
      <WITBWrapper>
        <div>
          <PlayerImage src="/images/players/homa.jpg" />
        </div>
        <ItemsWrapper>
          <Items>
            <Item name="Cobra DS-Adapt LS" description="Driver" image="/images/bags/homa/cobra_driver.png" />
            <Item name="Cobra Limit3d" description="Železá" image="/images/bags/homa/cobra_limited.png" />
            <Item name="Cobra King CB" description="Železá" image="/images/bags/homa/cobra_king_cb.png" />
            <Item name="Cobra King MB" description="Železá" image="/images/bags/homa/cobra_king_mb.png" />
            <Item name="Cobra Snakebite" description="Wedge" image="/images/bags/homa/cobra_snakebite.png" />
            <Item name="Cobra King Prototype" description="Wedge" image="/images/bags/fowler/king_cobra.png" />
          </Items>
        </ItemsWrapper>
      </WITBWrapper>
    )
  }

  return null
}

export default WITB

const WITBWrapper = styled.div<{ reversed?: boolean }>`
  display: grid;
  margin-top: 3rem;

  ${({ reversed }) => (reversed ? 'grid-template-columns: 5fr 2fr;' : 'grid-template-columns: 2fr 5fr;')}

  @media screen and (max-width: ${device.midleDesktop}) {
    grid-template-columns: 1fr;
  }
`

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${ColorsMap.white};
  padding: 2rem;

  @media screen and (max-width: ${device.midleDesktop}) {
    grid-row: 2 / 3;
  }
`

const ItemImageWrapper = styled.div`
  width: 20%;

  @media screen and (max-width: ${device.mobile}) {
    width: 60%;
  }
`

const Items = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;

  align-items: center;
  margin-top: 2rem;

  @media screen and (max-width: ${device.mobile}) {
    flex-wrap: wrap;
    width: 100%;
    margin-top: 4rem;
    gap: 4rem;
  }
`

const ItemImage = styled.img`
  margin-bottom: 1rem;
`

const BagImage = styled.img`
  width: 40%;

  @media screen and (max-width: ${device.tablet}) {
    width: 75%;
  }

  @media screen and (max-width: ${device.mobile}) {
    width: 100%;
  }
`

const PlayerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
